module.exports = __webpack_public_path__ + "img/logo_welcome.0496606d.svg";